import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip, Toggle } from 'decap-cms-ui-next';
import { jsx as ___EmotionJSX } from "@emotion/react";
function ToolbarButton({
  children,
  type,
  label,
  icon,
  hasMenu,
  onClick,
  isActive,
  disabled
}) {
  return ___EmotionJSX(Tooltip, {
    label: label,
    enterDelay: 1000,
    anchorOrigin: {
      y: 'top',
      x: 'center'
    },
    transformOrigin: {
      y: 'bottom',
      x: 'center'
    }
  }, ___EmotionJSX("div", null, ___EmotionJSX(Toggle, {
    pressed: isActive,
    disabled: disabled,
    onPressedChange: event => onClick && onClick(event, type),
    icon: icon,
    hasMenu: hasMenu
  }, children)));
}
ToolbarButton.propTypes = {
  type: PropTypes.string,
  label: PropTypes.string.isRequired,
  icon: PropTypes.string,
  onClick: PropTypes.func,
  isActive: PropTypes.bool,
  disabled: PropTypes.bool
};
export default ToolbarButton;